import React from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../helpers/utils';

const MultichoiceElement = ({
  name,
  label,
  lexicon,
  id,
  font,
  is_required = false,
  value,
  onChange = () => {},
  className = '',
  error,
  disabled = false,
  attributes,
}) => {
  // Parse HTML from text if it contains HTML tags
  const parseText = text => {
    if (!text) return '';
    // Remove HTML tags and decode entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Use label if available, otherwise fall back to name
  const labelText = label || name;
  const displayText = parseText(labelText);
  // Use component ID as fallback key if lexicon is null
  const valueKey = lexicon || `multichoice_${id}`;
  const isChecked = value === true || value === 'true' || value === displayText;

  const handleChange = () => {
    if (!disabled) {
      onChange(valueKey, !isChecked);
    }
  };

  // Get font properties - prefer component font if it has values, otherwise use form-level attributes font
  // This ensures form-level font settings are used as defaults
  const fontColor = font?.color || attributes?.font?.color;
  // Ensure fontSize is a string with 'px' unit if it's a number
  const rawFontSize = font?.size || attributes?.font?.size;
  const fontSize = typeof rawFontSize === 'number' ? `${rawFontSize}px` : rawFontSize;
  const fontStyle = font?.style || attributes?.font?.style;
  const fontFamily = font?.name || attributes?.font?.name;

  return (
    <MultichoiceElementWrapper className={className}>
      <div className="flex items-center cursor" onClick={handleChange}>
        <input
          type="checkbox"
          checked={isChecked}
          disabled={disabled}
          onChange={handleChange}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        />
        {displayText && (
          <label
            className="ml-1"
            style={{
              color: fontColor,
              fontSize: fontSize,
              fontWeight: getFontWeight(fontStyle),
              fontFamily: fontFamily,
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}>
            {displayText}
            {is_required && <span className="required-star">!</span>}
          </label>
        )}
      </div>
    </MultichoiceElementWrapper>
  );
};

const MultichoiceElementWrapper = styled('div')`
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  input[type='checkbox'] {
    cursor: pointer;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  label {
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
  }
`;

export default MultichoiceElement;
